import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ValidateService } from '../../../../@core/utils/validate.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'ngx-dynamic-text-input-group',
  templateUrl: './dynamic-text-input-group.component.html',
  styleUrls: ['./dynamic-text-input-group.component.scss'],
  providers: [ValidateService],
})
export class DynamicTextInputGroupComponent implements OnInit, OnDestroy {
  @Output() inputGroupValid = new EventEmitter<boolean>();
  @Output() inputsValues = new EventEmitter<{ id: number; value: string }[]>();
  @Input() displayName = 'text input';
  @Input() inputsArray: { id: number; value: string }[] = [];
  @Input() require: boolean = false;
  @Input() readonly: boolean = false;
  @Input() fireAlert: boolean = false;
  private subscription: ISubscription;
  valid: boolean;

  inputs = [];

  constructor(private validationService: ValidateService) {
    this.valid = true;
  }

  isInputValid(name: string, status: boolean) {
    this.validationService.updateFormFlag(name, status);
  }

  ngOnInit() {
    this.subscription = this.validationService.validStatus.subscribe(status => {
      this.inputGroupValid.emit(status);

      if (status) {
        const emitValues = this.inputs.map(obj => {
          return { id: obj.id, value: obj.value };
        });
        this.inputsValues.emit(emitValues);
      }
    });

    this.loadInputs();
  }
  loadInputs() {
    this.clearInputs();
    if (!Array.isArray(this.inputsArray) || this.inputsArray.length === 0) {
      this.addInput();
    } else {
      this.inputsArray.forEach(elem => {
        this.addInput(elem.id, elem.id, elem.value);
      });
    }
  }
  addInput(tempID: number = null, id: number = null, value: string = null) {
    let templateID = 0;
    let inputValue = '',
      inputID = 0;
    if (tempID) templateID = tempID;
    else templateID = Date.now();
    if (value) inputValue = value;
    if (id) inputID = id;
    this.inputs.push({ templateID: templateID, id: inputID, value: inputValue });
    this.validationService.addInputKey(('input-' + templateID).toString());
  }
  clearInputs() {
    this.inputs = [];
  }
  removeInput() {
    const lastID = this.inputs[this.inputs.length - 1].templateID;
    this.validationService.removeInputKey(('input-' + lastID).toString());
    this.inputs.pop();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
